module.exports = require('./lib/compiler').default
